import { Directive, Input } from '@angular/core';
import { WorkflowItem } from '@schenck/rotec-components';
import { MachinesSearchService, ToolingSearchService } from 'src/services';

@Directive()
export abstract class StepBaseComponent {
  @Input() public workflowItem: WorkflowItem;
  public appliedSearchText = '';
  public file: File;

  constructor(
    public machinesService: MachinesSearchService,
    public toolingService: ToolingSearchService
  ) {}

  public search(value: string, service: 'machines' | 'tooling'): void {
    service === 'machines'
      ? this.machinesService.fulltextSearch(value)
      : this.toolingService.fulltextSearch(value);
    this.appliedSearchText = value;
  }

  public updateWorkflowItem(service?: 'machines' | 'tooling'): void {
    this.workflowItem.valid =
      (service === 'machines'
        ? !!this.machinesService.state.selectedIds.length
        : !!this.toolingService.state.selectedIds.length) || !!this.file;
  }

  public selectedResultsChange(service: 'machines' | 'tooling', event?: string[]): void {
    if (service === 'machines') {
      this.machinesService.setSelected(event || []);
      this.updateWorkflowItem('machines');
    } else {
      this.toolingService.setSelected(event || []);
      this.updateWorkflowItem('tooling');
    }
  }
}
